import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { animated } from "react-spring";
import { useDraggable } from "../../hooks/useDraggable";
import { EntityChip } from "./EntityChip";
const AnimatedEntityChip = animated(EntityChip);
export const DraggableChipList = ({ objects, objectToName, objectToChipProps, className, renderChip, onDeleteObject, chipHeight, objectToChipHeight, onChangeOrder, loadingChip, }) => {
    const draggableObjects = objects.map((obj, index) => ({
        id: obj.id,
        index,
        height: objectToChipHeight ? objectToChipHeight(obj) : chipHeight,
    }));
    const { springs, bind } = useDraggable(draggableObjects, onChangeOrder);
    const renderDraggableChip = (obj) => {
        const springObject = draggableObjects.find(({ id }) => id === obj.id);
        if (!springObject)
            return;
        const spring = springs[springObject.index];
        const bindProps = bind(springObject.index);
        return renderChip ? (renderChip(obj, bindProps, spring)) : (
        // TODO: A generic entity chip is not fully functional in the drag case yet
        _jsx(AnimatedEntityChip, { label: objectToName(obj), onDelete: onDeleteObject ? () => onDeleteObject(obj) : undefined, chipProps: objectToChipProps ? objectToChipProps(obj) : {}, ...bindProps }, obj.id));
    };
    return (_jsxs("div", { className: className, children: [objects.map(obj => renderDraggableChip(obj)), loadingChip] }));
};
//# sourceMappingURL=Draggable.js.map